import { Typography } from 'components';
import { renderMetric } from 'views/Results/Conditions/ConditionMetricPill';
import { useEvaluationGroups } from 'views/Results/Insights/hooks/useEvaluationGroups';
import styles from './MainFindingsEvaluations.module.css';

export default function MainFindingsEvaluations() {
  const { greenSubMetrics, greySubMetrics, orangeSubMetrics, redSubMetrics } =
    useEvaluationGroups();

  return (
    <div className={styles.container}>
      <EvaluationBox length={redSubMetrics.length} color='red' separator />
      <EvaluationBox
        length={orangeSubMetrics.length}
        color='orange'
        separator
      />
      <EvaluationBox length={greySubMetrics.length} color='grey' separator />
      <EvaluationBox length={greenSubMetrics.length} color='green' />
    </div>
  );
}

type EvaluationBoxProps = {
  color: 'green' | 'grey' | 'orange' | 'red';
  length: number;
  separator?: boolean;
};

const texts: Record<EvaluationBoxProps['color'], string> = {
  red: 'Support',
  orange: 'Improve',
  grey: 'Okay',
  green: 'Great',
};

function EvaluationBox({
  color,
  length,
  separator = false,
}: EvaluationBoxProps) {
  return (
    <div className={styles.evaluationBox}>
      <div className={styles.information}>
        <Typography variant='body-s'>{texts[color]}</Typography>
        {renderMetric({
          count: length,
          color,
          styleClass: styles[color],
          showOnZero: true,
        })}
      </div>
      {separator && <div className={styles.separator} />}
    </div>
  );
}
